import { render, staticRenderFns } from "./MediaTile.vue?vue&type=template&id=31343c53&"
import script from "./MediaTile.vue?vue&type=script&lang=js&"
export * from "./MediaTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports